<template>
  <div class="page">
    <div class="center">
      <h1>{{ $t("maintenancePage.title") }}</h1>
      <div>
        <p>{{ $t("maintenancePage.description") }}</p>
        <p class="maintenance-date">{{ $t("maintenancePage.maintenancePeriod") }}</p>
      </div>
      <router-link to="/">
        <button class="button-top">{{ $t("maintenancePage.backToTop") }}</button>
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/style-common.scss";

.page {
  position: relative;
  padding: 10px;
  height: 100vh;
  width: 100vw;
  background-color: var(--color-background-normal);
}

h1 {
  color: var(--color-text-normal);
}

p {
  color: var(--color-text-normal);
}

.maintenance-date {
  font-size: var(--font-size-sm);
  color: var(--color-text-low);
}

.center {
  margin: 100px 10%;
  padding: 30px 50px;
  background-color: var(--color-surface-subtle);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-normal);
  border-radius: var(--radius-sm);

  @include mq(sp) {
    margin: 100px 0;
    padding: 30px 15px;
  }
}

.button-top {
  position: relative;
  @include hover-overlay;
  float: center;
  text-align: center;
  text-decoration: none;
  width: 250px;
  padding: 15px 50px;
  margin: 30px auto;
  border: solid 1px var(--color-border);
  background-color: var(--color-surface-muted);
  color: var(--color-text-normal);
  border-radius: var(--radius-rounded);
  cursor: pointer;

}
</style>
